module.exports = __webpack_public_path__ + "img/买一赠一.e549a1e8.png";